const COUNTRY_CODES_JA = {
    1: "日本",
};

const COUNTRY_CODES_EN = {
    1: "Japan",
};

const COUNTRY_CODES_JA_REVERSE = Object.assign(
    {},
    ...Object.entries(COUNTRY_CODES_JA).map(([a, b]) => ({ [b]: a }))
);

const COUNTRY_CODES_EN_REVERSE = Object.assign(
    {},
    ...Object.entries(COUNTRY_CODES_EN).map(([a, b]) => ({ [b]: a }))
);

export const PREFECTURES_JA = {
    1: "北海道",
    2: "青森県",
    3: "岩手県",
    4: "宮城県",
    5: "秋田県",
    6: "山形県",
    7: "福島県",
    8: "茨城県",
    9: "栃木県",
    10: "群馬県",
    11: "埼玉県",
    12: "千葉県",
    13: "東京都",
    14: "神奈川県",
    15: "新潟県",
    16: "富山県",
    17: "石川県",
    18: "福井県",
    19: "山梨県",
    20: "長野県",
    21: "岐阜県",
    22: "静岡県",
    23: "愛知県",
    24: "三重県",
    25: "滋賀県",
    26: "京都府",
    27: "大阪府",
    28: "兵庫県",
    29: "奈良県",
    30: "和歌山県",
    31: "鳥取県",
    32: "島根県",
    33: "岡山県",
    34: "広島県",
    35: "山口県",
    36: "徳島県",
    37: "香川県",
    38: "愛媛県",
    39: "高知県",
    40: "福岡県",
    41: "佐賀県",
    42: "長崎県",
    43: "熊本県",
    44: "大分県",
    45: "宮崎県",
    46: "鹿児島県",
    47: "沖縄県",
};

const PREFECTURES_EN = {
    1: "Hokkaido",
    2: "Aomori",
    3: "Iwate",
    4: "Miyagi",
    5: "Akita",
    6: "Yamagata",
    7: "Fukushima",
    8: "Ibaraki",
    9: "Tochigi",
    10: "Gumma",
    11: "Saitama",
    12: "Chiba",
    13: "Tokyo",
    14: "Kanagawa",
    15: "Niigata",
    16: "Toyama",
    17: "Ishikawa",
    18: "Fukui",
    19: "Yamanashi",
    20: "Nagano",
    21: "Gifu",
    22: "Shizuoka",
    23: "Aichi",
    24: "Mie",
    25: "Shiga",
    26: "Kyoto",
    27: "Osaka",
    28: "Hyogo",
    29: "Nara",
    30: "Wakayama",
    31: "Tottori",
    32: "Shimane",
    33: "Okayama",
    34: "Hiroshima",
    35: "Yamaguchi",
    36: "Tokushima",
    37: "Kagawa",
    38: "Ehime",
    39: "Kochi",
    40: "Fukuoka",
    41: "Saga",
    42: "Nagasaki",
    43: "Kumamoto",
    44: "Oita",
    45: "Miyazaki",
    46: "Kagoshima",
    47: "Okinawa",
};

const PREFECTURES_JA_REVERSE = Object.assign(
    {},
    ...Object.entries(PREFECTURES_JA).map(([a, b]) => ({ [b]: a }))
);

const PREFECTURES_EN_REVERSE = Object.assign(
    {},
    ...Object.entries(PREFECTURES_EN).map(([a, b]) => ({ [b]: a }))
);

const CREDIT_CARD_BRAND_CODES_JA = {
    10: "VISA",
    20: "JCB",
    30: "Master Card",
    40: "American Express",
};

export const CREDIT_CARD_BRAND_CODES_EN = {
    10: "VISA",
    20: "JCB",
    30: "Master Card",
    40: "American Express",
};

const PAYMENT_STATUS_JA = {
    // 申込済
    10: '新規受付',
    // 速報
    39: '入金待ち',
    // 消込済
    40: '入金済み',
    // 消込済（一部入金）
    41: '入金金額不足',
    // 消込済（過入金）
    42: '入金済み（過入金）',
    // 消込済（依頼入金）
    43: '入金済み',
    // 消込済（依頼入金・重複）
    44: '入金済み',
    // 消込済（対応済）
    45: '入金済み',
    // 取消済
    60: 'キャンセル',
    // 速報取消
    61: 'キャンセル',
    // 決済失敗
    80: '決済失敗',
    // 支払期限超過
    90: '支払期限切れ',
};

const PAYMENT_STATUS_EN = {
    // 申込済
    10: '新規受付',
    // 速報
    39: '入金待ち',
    // 消込済
    40: '入金済み',
    // 消込済（一部入金）
    41: '入金金額不足',
    // 消込済（過入金）
    42: '入金済み（過入金）',
    // 消込済（依頼入金）
    43: '入金済み',
    // 消込済（依頼入金・重複）
    44: '入金済み',
    // 消込済（対応済）
    45: '入金済み',
    // 取消済
    60: 'キャンセル',
    // 速報取消
    61: 'キャンセル',
    // 決済失敗
    80: '決済失敗',
    // 支払期限超過
    90: '支払期限切れ',
};

export const STATUS_CLASS = {
    "active": "is-active",
    "resigned": "is-delete",
    "merch_suspended": "is-stop"
}

const STATUS_DATE_LABEL_EN = {
    active: 'Registed',
    resigned: 'Resigned',
    merch_suspended: 'Closed',
};

const STATUS_DATE_LABEL_JP = {
    active: '登録日',
    resigned: '退会日',
    merch_suspended: '閉鎖日',
};

export const HTTP_CODE_SUCCESS = 200;
export const HTTP_CODE_CREATED = 201;
export const HTTP_CODE_BAD_REQUEST = 400;
export const HTTP_CODE_NOT_FOUND = 404;
export const HTTP_CODE_SERVER_ERROR = 500;

export const CARD_BRAND_VISA = 10;
export const CARD_BRAND_JCB = 20;
export const CARD_BRAND_MASTER = 30;
export const CARD_BRAND_AMERICAN_EXPRESS = 40;

export const PAYMENT_TYPE_CREDIT_CARD = 20;

export const COUNTRY_CODE_JA = 1;

const CREDIT_CARD_BRAND_CODES_JA_REVERSE = Object.assign(
    {},
    ...Object.entries(CREDIT_CARD_BRAND_CODES_JA).map(([a, b]) => ({ [b]: a }))
);

const CREDIT_CARD_BRAND_CODES_EN_REVERSE = Object.assign(
    {},
    ...Object.entries(CREDIT_CARD_BRAND_CODES_EN).map(([a, b]) => ({ [b]: a }))
);

export default {
    en: {
        COUNTRY_CODES: COUNTRY_CODES_EN,
        COUNTRY_CODES_REVERSE: COUNTRY_CODES_EN_REVERSE,
        PREFECTURES: PREFECTURES_EN,
        PREFECTURES_REVERSE: PREFECTURES_EN_REVERSE,
        CREDIT_CARD_BRAND_CODES: CREDIT_CARD_BRAND_CODES_EN,
        CREDIT_CARD_BRAND_CODES_REVERSE: CREDIT_CARD_BRAND_CODES_EN_REVERSE,
        PAYMENT_STATUS: PAYMENT_STATUS_EN,
        STATUS_DATE_LABEL: STATUS_DATE_LABEL_EN,
    },
    ja: {
        COUNTRY_CODES: COUNTRY_CODES_JA,
        COUNTRY_CODES_REVERSE: COUNTRY_CODES_JA_REVERSE,
        PREFECTURES: PREFECTURES_JA,
        PREFECTURES_REVERSE: PREFECTURES_JA_REVERSE,
        CREDIT_CARD_BRAND_CODES: CREDIT_CARD_BRAND_CODES_JA,
        CREDIT_CARD_BRAND_CODES_REVERSE: CREDIT_CARD_BRAND_CODES_JA_REVERSE,
        PAYMENT_STATUS: PAYMENT_STATUS_JA,
        STATUS_DATE_LABEL: STATUS_DATE_LABEL_JP,
    },
};

export const BAD_REQUEST_ERROR_CODE = 400;

export const SUCCESS_CODE = 200;
export const HEADER_KEY_SSID = "hvc-hubsynch-ssid";
export const HEADER_KEY_AUTH_ID = "hvc-hubsynch-auth-id";

export const API_RESPONSE_SUCCESS = 1;

export const MALE = 1;
export const FEMALE = 2;
export const OTHER = 3;

export const GENDER_LIST = {
    1: "男性",
    2: "女性",
    3: "その他"
};

export const COUNTRY_CODE_JAPAN = 1;

export const PAYMENT_STATUS_CLASS = {
    // Payment in process — Blue
    10: "status--processing",
    39: "status--processing",

    // Payment completed — Green
    40: "status--completed",
    41: "status--completed",
    42: "status--completed",
    43: "status--completed",
    44: "status--completed",
    45: "status--completed",

    // Cancelled — probablemente red o gris
    60: "status--cancelled",
    61: "status--cancelled",

    // Payment failure — Red
    80: "status--failed",

    // Deadline passed — Purple
    90: "status--expired",
};